<app-breadcrumb></app-breadcrumb>

<div class="container-fluid">

  <h1><strong>BULGARI CATALOGO TERMS OF USE</strong></h1>
  <p>

    These Terms of Use govern your access to and use of the BULGARI
    CATALOGO an informative tool (the "Tool") operated by Bulgari S.p.A.
    ("Bulgari," "we," "us," or "our") for the exclusive use of the employees of
    the Bulgari Group. Please read these Terms of Use carefully before using
    the Tool.


    Your access to and use of the Tool is conditioned on your acceptance of
    and compliance with these Terms of Use. These Terms of Use apply to
    all users who access or use the Tool.


  </p>
  <h2><strong>1. ACCEPTANCE OF TERMS</strong></h2>
  <p>

    By accessing or using any part of the Tool, you agree to accept and
    comply with these Terms of Use. These Terms of Use constitute a
    binding agreement between you and us. You are responsible for
    regularly reviewing the Terms of Use. You can review the most current
    version of the Terms of Use at any time within the Tool. If you do not
    wish to be bound by these Terms of Use, please do not access or use
    any part of the Tool.


  </p>
  <h2><strong>2. ELIGIBILITY</strong></h2>
  <p>

    Use of the Tool is strictly limited to Bulgari Group employees specifically
    authorized based on their job function. If your job function changes,
    such that you no longer have a business need to use the Tool, you must
    immediately cease using the Tool and notify your local IT department.


  </p>
  <h2><strong>3. CONFIDENTIALITY AND NON-DISCLOSURE</strong></h2>
  <p>

    You acknowledge that the information and content available through the
    Tool may contain confidential and proprietary information belonging to
    Bulgari, its affiliates, and/or third parties. While not all information may
    be strictly confidential,
    $
    You agree that it is opportune not to disclose such information to any
    unauthorized person or entity. You agree to refrain from disclosing any
    information obtained through the Tool to any unauthorized person or
    entity. This non-disclosure obligation shall survive the termination of
    your employment relationship or access to the Tool.


  </p>
  <h2><strong>4. INTELLECTUAL PROPERTY</strong></h2>
  <p>

    The intellectual property rights to contents uploaded to the Tool remain
    the property of Bulgari and/or the entity that uploaded the content. By
    using the Tool, you acknowledge this ownership and agree not to take
    any action that would infringe upon these rights.


  </p>
  <h2><strong>5. USE OF CONTENT</strong></h2>
  <p>

    The content provided within the Tool is provided "as is" for informational
    purposes only. It should not be used without careful review and
    consideration of its applicability to specific situations. The content
    within the Tool is intended to support, not replace, your own
    professional judgment.

    The content within the Tool shall only be used in connection with your
    functions as an employee within the Bulgari Group. Use of the content
    for personal purposes, external purposes outside of your job function,
    or commercial use is strictly prohibited.


  </p>
  <h2><strong>6. DISCLAIMERS AND LIMITATIONS OF LIABILITY</strong></h2>
  <p>

    TO THE FULLEST EXTENT PERMITTED BY LAW, UNDER NO
    CIRCUMSTANCE WHATSOEVER SHALL BULGARI AND ITS
    AFFILIATES BE LIABLE FOR ANY LOSSES ARISING OUT OF OR IN
    CONNECTION WITH THE USE OF THE TOOL.

    OTHER THAN AS REQUIRED BY APPLICABLE LAW, IN NO EVENT
    WILL BULGARI AND/OR ITS AFFILIATES BE LIABLE FOR ERRORS
    OR OMISSIONS IN THE TOOL AND/OR ITS CONTENTS OR FOR
    ANY LOSSES OR DAMAGES, DIRECT, INDIRECT, INCIDENTAL,
    SPECIAL OR CONSEQUENTIAL RESULTING FROM YOUR USE OF,
    OR RELIANCE ON, THE TOOL AND/OR ITS CONTENTS.
    THE TOOL IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, WITHOUT
    LIMITATION, ANY WARRANTY FOR INFORMATION, UPTIME OR
    UNINTERRUPTED ACCESS, ANY WARRANTIES CONCERNING THE
    AVAILABILITY, ACCURACY, USEFULNESS, OR CONTENT OF
    INFORMATION, AND ANY WARRANTIES OF TITLE, NONINFRINGEMENT, MERCHANTABILITY OR FITNESS FOR A
    PARTICULAR PURPOSE, AND WE HEREBY DISCLAIM ANY AND ALL
    SUCH WARRANTIES, EXPRESS AND IMPLIED. We do not warrant
    that the Tool or materials contained therein will be timely, secure,
    uninterrupted or error free, or that defects will be corrected. We make
    no warranty that the Tool will meet user’s requirements. Bulgari also
    assume no responsibility, and shall not be liable for, any damages to, or
    viruses, worms, trojan horses or other harmful material that may infect
    your computer equipment or other property on account of your access
    to, use of, or browsing in the Tool or your downloading of any materials,
    data, text, images, video, or audio from the Tool.


  </p>
  <h2><strong>7. INDEMNIFICATION</strong></h2>
  <p>

    You agree to defend, indemnify and hold Bulgari, its affiliates, and its
    and their directors, officers, employees and agents harmless from any
    and all claims, liabilities, costs and expenses, including reasonable
    attorneys' fees, arising in any way from your use of the Tool, your
    disclosure of any Tools’ content, or your breach or violation of the law or
    of these Terms of Use, excluding the gross negligence or willful
    misconduct of Bulgari. Bulgari reserves the right, at its own expense, to
    assume the exclusive defense and control of any matter otherwise
    subject to indemnification by you, and in such case, you agree to
    cooperate with Bulgari’s defense of such claim.


  </p>
  <h2><strong>8. PROHIBITED CONDUCT</strong></h2>
  <p>

    You shall not: (i) obtain or attempt to obtain unauthorized access to
    computer systems, materials, information or any services made
    available on or through the Tool through any means;
    (ii) use the Tool or the services made available on or through the Tool in
    any manner with the intent to interrupt, damage, disable, overburden,
    impair the Tool or such services, or interfere with any other party’s use
    and enjoyment of the Tool including, without limitation, sending mass
    unsolicited messages or “flooding” servers with requests; (iii) use the
    Tool or the Tool’s services or features in violation of Bulgari’s or any
    third party’s intellectual property or other proprietary or legal rights; or
    (iv) use the Tool or the Tool’s services in violation of any applicable law.
    You further agree that the content within this Tool shall not be used to
    train artificial intelligence (AI) tools or machine learning models. You
    further agree that you may not attempt (or encourage or support
    anyone else’s attempt) to circumvent, reverse engineer, decrypt, or
    otherwise alter or interfere with the Tool and the content, or make
    unauthorized use thereof.


  </p>
  <h2><strong>9. SECURITY</strong></h2>
  <p>

    You must not engage in any activity that disrupts or impairs the proper
    functioning of the Tool nor attempt to overload, disable, or otherwise
    compromise the Tool or its resources through unauthorized means.


  </p>
  <h2><strong>10. TERMINATION</strong></h2>
  <p>

    We may change, suspend or discontinue this Tool at any time. We may
    restrict, suspend or terminate your access to the Tool if we believe you
    are in breach of our Terms of Use or applicable law, or for any other
    reason without notice or liability. All provisions of the Terms of Use
    which by their nature should survive termination shall survive
    termination, including, without limitation, ownership provisions,
    warranty disclaimers, indemnity and limitations of liability.


  </p>
  <h2><strong>11. CHANGES</strong></h2>
  <p>

    We reserve the right, at our sole discretion, to modify or replace these
    Terms of Use at any time. Your continued use of the Tool following the
    posting of any changes to these Terms of Use constitutes acceptance of
    those changes.
  </p>

  <p>
    © Bulgari S.p.A.
    <br>
    Last updated: 08/10/2025
  </p>

</div>
